import { COUNTRIES } from '@wareclouds/frontend-common';

import { CONTEXT } from '@/config/consts/commons';
import {
  CREATE_LEAD_MAGIC_LINK_SENT,
  EXTERNAL_VALIDATION_INVALID_RESPONSE,
} from '../utils/leadApi.constants';
import { LEAD_EVENT_STAGES } from '../../constants/leadEventStages';

import { normalizeProfilePhoneForApi } from '../utils';
import { joinNameParts } from '../utils';

export function mapLeadEvent(dto) {
  return {
    id: dto.id_lead_event,
    leadId: dto.id_lead,
    stage: dto.stage,
    content: dto.content,
    context: dto.id_context,
  };
}

export function mapLeadEvents(dto) {
  if (!dto?.data) return [];
  return dto.data.map(mapLeadEvent);
}

export function mapRequestExternalValidationResponse(dto) {
  if (!dto?.data) {
    return { ok: false, errorCode: EXTERNAL_VALIDATION_INVALID_RESPONSE };
  }
  return { ok: true, event: mapLeadEvent(dto.data) };
}

export function mapCreateLeadResponse(dto) {
  const message = dto?.message ?? '';
  return {
    magicLinkSent: message === CREATE_LEAD_MAGIC_LINK_SENT,
    message,
  };
}

export function getConcatenatedProfileNames(values) {
  if (CONTEXT === COUNTRIES.CL) {
    return {
      first_name: joinNameParts(values.given_name, values.middle_name),
      last_name: joinNameParts(values.first_last_name, values.second_last_name),
    };
  }
  return {
    first_name: (values.first_name ?? '').trim(),
    last_name: (values.last_name ?? '').trim(),
  };
}

export function mapCompleteProfileToBasicProfileEventPayload(values) {
  const { first_name, last_name } = getConcatenatedProfileNames(values);
  const regionId =
    typeof values.region === 'object' && values.region != null
      ? values.region.value
      : values.region;
  const cityId =
    typeof values.municipality === 'object' && values.municipality != null
      ? values.municipality.value
      : values.municipality;

  return {
    stage: LEAD_EVENT_STAGES.BASIC_PROFILE,
    content: {
      first_name,
      last_name,
      phone: normalizeProfilePhoneForApi(values.phone),
      id_city: Number(cityId),
      id_region: Number(regionId),
    },
  };
}
